import { User } from "@/entities";
import { userFromDTO } from "@/services/user/dto";
import { AxiosInstance } from "axios";

/**
 * Queries the authenticated user information.
 */
export default class AuthUserService {
  private _httpClient: AxiosInstance;

  constructor(httpClient: AxiosInstance) {
    this._httpClient = httpClient;
  }
  public async getUser(): Promise<User> {
    const response = await this._httpClient.get("auth-user");
    return userFromDTO(response.data);
  }

  public async logout(): Promise<void> {
    await this._httpClient.post("logout");
  }
}
